// extracted by mini-css-extract-plugin
export default {"brandPromo":"dF-z","carousel":"eF-z"};